import type { Theme } from './types'

export const baseTheme: Theme = {
  name: 'base',
  colors: {
    // Primary flat professional blue
    primary: '#007bff',
    secondary: '#6c757d',
    
    // Flat backgrounds
    background: '#f8f9fa',
    surface: '#ffffff',
    
    // Text colors with high contrast
    text: '#212529',
    textSecondary: '#6c757d',
    
    // Clean flat border
    border: '#dee2e6',
    
    // Status colors - flat, no gradients
    success: '#28a745',
    warning: '#ffc107',
    error: '#dc3545',
    
    // Order status colors (flat design)
    statusDraft: '#6c757d',      // Gray
    statusSubmitted: '#007bff',   // Blue
    statusConfirmed: '#28a745',   // Green
    statusBilled: '#ffc107',      // Amber
    statusCompleted: '#17a2b8',   // Teal
  },
  spacing: {
    xs: '0.25rem',   // 4px
    sm: '0.5rem',    // 8px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '3rem',      // 48px
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    fontSize: {
      sm: '0.875rem',   // 14px
      md: '1rem',       // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 600,
    },
  },
  borderRadius: {
    sm: '0.25rem',  // 4px - minimal rounded
    md: '0.375rem', // 6px - subtle rounded
    lg: '0.5rem',   // 8px - slightly more rounded
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',     // Very subtle
    md: '0 1px 3px rgba(0, 0, 0, 0.1)',      // Light shadow
    lg: '0 4px 6px rgba(0, 0, 0, 0.1)',      // Modal shadow
  },
} 